var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.selectedNutritionLabelComponent,{key:_vm.selectedCountry,tag:"component",attrs:{"nutrition":_vm.nutrition,"show-rounded-dv":_vm.showRoundedDv,"servings-per-container":_vm.servingsPerContainer,"is-supplement-label":_vm.isSupplementLabel}})
}
var staticRenderFns = []

export { render, staticRenderFns }